import { type AnyAction, combineReducers } from 'redux';

import PlainJsStoreORM from 'js/src/data/plain-js-store-orm';
import {
    storeSupportedLanguages,
    storeVideoTranslations,
} from 'js/src/data/translations/translations-actions';
import type {
    ReadonlySlideTranslatedText,
    ReadonlySupportedLanguage,
} from 'js/src/data/translations/translations-types';

const NO_SUPPORTED_LANGUAGES: readonly ReadonlySupportedLanguage[] = [];

export function translations(
    state = PlainJsStoreORM.createEmpty<ReadonlySlideTranslatedText, string>().data,
    action: AnyAction,
) {
    if (storeVideoTranslations.match(action)) {
        const orm = new PlainJsStoreORM(state);
        action.payload.translations.forEach((translation) => {
            orm.pushItem(
                { slide_id: translation.slide_id, message: translation.message },
                'slide_id',
            );
        });
        return orm.data;
    }
    return state;
}

export function supported_languages(state = NO_SUPPORTED_LANGUAGES, action: AnyAction) {
    if (storeSupportedLanguages.match(action)) {
        return action.payload.supported_languages;
    }
    return state;
}

export const translationsReducer = combineReducers({
    translations,
    supported_languages,
});

export type TranslationsState = ReturnType<typeof translationsReducer>;
